import { Loader } from '@design-system/Loader';

export const LoadingPage = () => {
  return <Loader />;
};
